export default __webpack_public_path__ + "static/media/yellow-watercolor.84889fc7.png";